import {default as actions} from './action';
import {
    SAVED, SAVEAS, CONFIRM_TYPE, FILEPATH, FILE, RENAME,
    SYNC_PROJECTS, OPEN_PROJECT, DOWNLOAD_PROJECT, UPLOAD_PROJECT, DELETE_PROJECT,
    COPY_PROJECT, SHARE_PROJECT, UPLOAD_COVERIMG, CLEAR_PROJECTS, SEARCH, UPDATE_PRE_PROJECT_DATA_STRING, UPDATE_PROJECT_LOADED_STATE
} from './actionTypes';

const defaultState = {
    // 确认保存的类型
    confirmSaveType: null,
    // 已保存或打开的项目文件路径
    filePath: null,
    // 选择打开的项目 (File 对象)
    file: null,
    // 同步过程显示标志
    syncLabel: '',
    // 项目本地id
    id: '',
    // 项目云端id
    projectId: '',
    // 项目commitId
    commitId: '',
    // 项目名称
    name: '',
    // 确定保存的项目名称
    isConfirmName: false,
    // 项目本地文件名称
    localName: '',
    // 是否为加载的示例项目
    // isExample: false,
    // 打开的项目类型（example，local，list）
    projectType: '',
    // 项目状态
    projectStatus: '',
    // 是否为重命名
    isReName: false,
    // 项目创建时间或更新时间
    createdAt: '',
    // 项目封面
    coverImage: '',
    // 同步完成作品列表
    projects: [],
    // 读取本地所有文件列表对象
    localList: {},
    // 下载文件进度
    downloadStatus: {
        err: null,
        percent: 0
    },
    // 保存状态返回
    saveStatus: '',
    // 保存进度
    saveProgress: 0,
    // 搜素字段
    searchText: '',
    // 原项目数据
    preProjectData: '',
    // 当前进行同步的用户Id，用于判断数据第一次读local，往后读store
    currentUserId: 'null',
    // 是否是自己的作品
    isSelfProject: true,
    // 是否是已发布的作品
    isShare: false,
    showLoadingPage: true,
    // 该项目是否为分享给第三方平台的项目
    isForThirdPlatform: false
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case SAVED:
        case SAVEAS:
        case CONFIRM_TYPE:
        case FILE:
        case FILEPATH:
        case RENAME:
        case SYNC_PROJECTS:
        case OPEN_PROJECT:
        case DOWNLOAD_PROJECT:
        case UPLOAD_PROJECT:
        case DELETE_PROJECT:
        case COPY_PROJECT:
        case CLEAR_PROJECTS:
        case UPLOAD_COVERIMG:
        case SHARE_PROJECT:
        case SEARCH:
        case UPDATE_PRE_PROJECT_DATA_STRING:
        case UPDATE_PROJECT_LOADED_STATE:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
};

export default {
    reducer,
    actions
};